import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/components/views/Home.vue';
import Login from '@/components/views/auth/Login.vue';
import Profile from '@/components/views/auth/Profile.vue';
import Register from '@/components/views/auth/Register.vue';

import Addons from '@/components/features/addons/Addons.vue';
import CalendarPage from '@/components/features/calendar/CalendarPage.vue';
import Chat from '@/components/features/communicate/Chat.vue';
import Manage from '@/components/features/manage/Manage.vue';
import ManageChores from '@/components/features/manage/chores/ManageChores.vue';
import ManageDashboard from '@/components/features/manage/dashboard/ManageDashboard.vue';
import ManageMembers from '@/components/features/manage/members/ManageMembers.vue';
import ManageRooms from '@/components/features/manage/rooms/ManageRooms.vue';
import Messages from '@/components/features/communicate/Messages';
import BasicSetup from '@/components/features/setup/basic/BasicSetup.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'home', meta: { layout: 'no-navigation' }, component: Home },
  { path: '/home', meta: { layout: 'no-navigation' }, component: Home },
  { path: '/login', meta: { layout: 'no-navigation' }, name: 'login', component: Login },
  { path: '/register', name: 'register', meta: { layout: 'no-navigation' }, component: Register },
  { path: '/profile', name: 'profile', meta: { layout: 'household-admin' }, component: Profile },

  { path: '/addons', name: 'addons', meta: { layout: 'household-admin', title: 'Addons' }, component: Addons },
  { path: '/calendar', name: 'calendar', meta: { layout: 'household-admin', title: 'Calendar' }, component: CalendarPage },
  { path: '/calendar/settings', name: 'calendar_settings', meta: { layout: 'household-admin', title: 'Calendar Settings' }, component: CalendarPage },
  { path: '/chores', name: 'chores', meta: { layout: 'household-admin', title: 'Chores' }, component: ManageChores },
  { path: '/chores/dashboard', name: 'chores_dashboard', meta: { layout: 'household-admin', title: 'Chores Dashboard' }, component: ManageChores },
  { path: '/chores/today', name: 'chores_today', meta: { layout: 'household-admin', title: "Today's Chores" }, component: ManageChores },
  { path: '/chores/upcoming', name: 'chores_upcoming', meta: { layout: 'household-admin', title: 'Upcoming Chores' }, component: ManageChores },
  { path: '/communicate', name: 'communicate', meta: { layout: 'household-admin', title: 'Communicate' }, component: ManageChores },
  { path: '/communicate/chat', name: 'chat', meta: { layout: 'household-admin', title: 'Chat' }, component: Chat },
  { path: '/communicate/messages', name: 'messages', meta: { layout: 'household-admin', title: 'Messages' }, component: Messages },
  { path: '/contacts', name: 'contacts', meta: { layout: 'household-admin', title: 'Contacts' }, component: ManageChores },
  { path: '/contacts/emergency', name: 'contacts_emergency', meta: { layout: 'household-admin', title: 'Emergency Contacts' }, component: ManageChores },
  { path: '/contacts/family', name: 'contacts_family', meta: { layout: 'household-admin', title: 'Family Contacts' }, component: ManageChores },
  { path: '/contacts/vendors', name: 'contacts_vendors', meta: { layout: 'household-admin', title: 'Vendor Contacts' }, component: ManageChores },
  { path: '/finance', name: 'finance', meta: { layout: 'household-admin', title: 'Finance' }, component: ManageChores },
  { path: '/finance/budget', name: 'finance_budget', meta: { layout: 'household-admin', title: 'Budget' }, component: ManageChores },
  { path: '/finance/bills', name: 'finance_bills', meta: { layout: 'household-admin', title: 'Bills' }, component: ManageChores },
  { path: '/finance/savings', name: 'finance_savings', meta: { layout: 'household-admin', title: 'Savings' }, component: ManageChores },
  { path: '/meals', name: 'meals', meta: { layout: 'household-admin', title: 'Meals' }, component: ManageChores },
  { path: '/meals/planner', name: 'meal_planner', meta: { layout: 'household-admin', title: 'Meal Planner' }, component: ManageChores },
  { path: '/meals/inventory', name: 'meal_inventory', meta: { layout: 'household-admin', title: 'Ingredient Inventory' }, component: ManageChores },
  { path: '/meals/recipes', name: 'meal_recipes', meta: { layout: 'household-admin', title: 'Recipes' }, component: ManageChores },
  { path: '/maintenance', name: 'maintenance', meta: { layout: 'household-admin', title: 'Maintenance' }, component: ManageChores },
  { path: '/maintenance/schedule', name: 'maintenance_schedule', meta: { layout: 'household-admin', title: 'Maintenance Schedule' }, component: ManageChores },
  { path: '/maintenance/log', name: 'maintenance_log', meta: { layout: 'household-admin', title: 'Maintenance Log' }, component: ManageChores },
  { path: '/manage', name: 'manage', meta: { layout: 'household-admin', title: 'Manage' }, component: Manage },
  { path: '/manage/dashboard', name: 'dashboard', meta: { layout: 'household-admin', title: 'Dashboard' }, component: ManageDashboard },
  { path: '/manage/members', name: 'members', meta: { layout: 'household-admin', title: 'Household Members' }, component: ManageMembers },
  { path: '/manage/rooms', name: 'rooms', meta: { layout: 'household-admin', title: 'Rooms' }, component: ManageRooms },
  { path: '/setup', name: 'setup', meta: { layout: 'household-admin', title: 'Setup' }, component: ManageChores },
  { path: '/setup/basic', name: 'setup', meta: { layout: 'household-admin', title: 'Basic Setup' }, component: BasicSetup },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router;
